<section
  *ngIf="showItem"
  [formGroup]="mainForm">
  <div
    *ngIf="needShowEnabled || labelForEnabledFields || subtitleForEnabledFields"
    class="form-row mb-1">
    <div class="col">
      <mbs-checkbox
        *ngIf="needShowEnabled; else enabledFieldsText"
        formControlName="enabledFields"
        [label]="labelForEnabledFields"
        [subtitle]="subtitleForEnabledFields"
        (change)="enabledFieldsChangeHandler($event)"
        [id]="'exclude-enabled-checkbox'"></mbs-checkbox>
      <ng-template #enabledFieldsText>
        {{ labelForEnabledFields }}<br />
        {{ subtitleForEnabledFields }}
      </ng-template>
    </div>
    <div class="col text-end">
      <div
        class="d-inline-block"
        container="body"
        placement="left-top bottom"
        [ngbTooltip]="'shared:buttons.pasteFromClipboardNotSupported' | i18next"
        [disableTooltip]="!pastFromClipboardNotSupported">
        <mbs-button
          container="body"
          placement="left-top bottom"
          type="primary"
          [size]="MbsSize.sm"
          icon="fa fa-paste"
          [ngbTooltip]="pasteTooltip"
          [disabled]="!mainForm.get('enabledFields').value || !!editedString || pastFromClipboardNotSupported"
          [isCtrl]="true"
          (click)="pasteFromClipboardHandler(error)">
          <span class="fw-semibold">{{ 'shared:buttons.paste_from_clipboard' | i18next }}</span>
        </mbs-button>
      </div>
    </div>
  </div>

  <mbs-form-group
    class="mb-1"
    [formGroup]="newPathForm">
    <div class="d-flex align-items-center justify-content-between">
      <mbs-input
        class="w-100"
        formControlName="newPath"
        [isErrorsShow]="false"
        [class.mr-1]="!needShowEnabled && !labelForEnabledFields && !subtitleForEnabledFields"
        [maxLength]="32767"
        [appendButtons]="[
          {
            icon: editedString ? 'fa fa-check-circle text-success' : 'fa fa-plus-circle',
            id: 'newPathsButton',
            disabled: newPathForm.get('newPath').disabled,
            type: 'secondary'
          },
          {
            icon: 'fa fa-close',
            id: 'closeNewPathsButton',
            disabled: false,
            hide: !editedString,
            type: 'secondary'
          }
        ]"
        [id]="'new-exclude-rule'"
        [buttonClickOnEnter]="!!newPathForm.get('newPath')?.value"
        [placeholder]="placeholderForEnabledFields"
        [validationWhitespace]="true"
        (blur)="newPathsBlur($event)"
        (buttonClick)="addNewPaths($event)"
        (input)="newPathInputHandler($event)"></mbs-input>
      <div
        *ngIf="!needShowEnabled && !labelForEnabledFields && !subtitleForEnabledFields"
        class="d-inline-block"
        container="body"
        placement="left-top bottom"
        [disableTooltip]="!pastFromClipboardNotSupported"
        [ngbTooltip]="'shared:buttons.pasteFromClipboardNotSupported' | i18next">
        <mbs-button
          container="body"
          icon="fa fa-paste"
          placement="left-top bottom"
          type="secondary"
          [disabled]="!mainForm.get('enabledFields').value || !!editedString || pastFromClipboardNotSupported"
          [ngbTooltip]="pasteTooltip"
          [size]="MbsSize.sm"
          (click)="pasteFromClipboardHandler(error)">
          <span class="fw-semibold">{{ 'shared:buttons.paste' | i18next }}</span>
        </mbs-button>
      </div>
    </div>
    <mbs-input-errors
      *ngIf="newPathForm?.get('newPath')?.errors"
      [errors]="[
        {
          message:
            newPathForm.get('newPath').errors.isSelected?.message ||
            newPathForm.get('newPath').errors.required?.message ||
            newPathForm.get('newPath').errors.invalidPath?.message
        }
      ]"></mbs-input-errors>
  </mbs-form-group>
  <div class="mt-1 pt-1">
    <mbs-card
      [size]="MbsSize.xs"
      [staticHeight]="163">
      <div
        class="form-row mb-2 align-items-center flex-nowrap _hover-parent"
        *ngFor="let str of mainForm.get('paths')?.value; let i = index">
        <div
          class="col-auto text-xs flex-shrink-1 text-overflow"
          [class.text-muted]="editedString && editedString.value !== str">
          <span
            ngbTooltip="{{ str }}"
            container="body"
            class="pre-wrap text-overflow"
            tooltipClass="tooltip-lg text-start">
            {{ str }}
          </span>
        </div>
        <div
          class="col-auto _hover-target"
          *ngIf="!newPathForm.get('newPath')?.disabled && !editedString">
          <div class="row align-items-center g-0 lh-1">
            <div class="col-auto">
              <mbs-button
                [isCtrl]="true"
                type="primary"
                icon="fa fa-pencil px-1"
                (click)="editHandler(i)"></mbs-button>
            </div>
            <div class="col-auto">
              <mbs-button
                [isCtrl]="true"
                type="primary"
                icon="fa fa-times-circle px-1"
                (click)="delExcludeRuleField(i)"></mbs-button>
            </div>
          </div>
        </div>
      </div>
    </mbs-card>
  </div>
</section>

<ng-template #pasteTooltip>
  <div class="tooltip_content text-start">
    {{ 'wizards:past_tooltip_text' | i18next }}<br />
    <ng-container *ngIf="!isUnix">
      D:\Folder 1<br />
      D:\Folder 2<br />
      D:\Folder 3
    </ng-container>
    <ng-container *ngIf="isUnix">
      /home/folder 1<br />
      /home/folder 2<br />
      /home/folder 3
    </ng-container>
  </div>
</ng-template>

<ng-template #error>
  <mbs-form-group>
    <img
      src="assets/clipboard.png"
      alt="No Backup Plans" />
  </mbs-form-group>
  {{ 'shared:validation.read_permission_error' | i18next }}
</ng-template>
